module.exports = __webpack_public_path__ + "static/media/minus.33602140.svg";